import t from "../locales";
import { getRandomPoster, getRandomTheme } from "./utils";
import * as Sentry from "@sentry/browser";

export function buildPostFromStore(store) {
  return buildPost(null, store.answers);
}

export function buildPostFromAggregator(data) {
  return buildPost(data.public_id, data.answers);
}

function buildPost(id, answers) {
  const age = answers.ages;
  const perspective = answers.perspectives;
  const category = answers.category;
  const fragment = answers.fragment;

  const title = answers.title;
  const who = answers.who;
  const what = answers.what;
  const where = answers.where;
  const why = answers.why;

  const direct = answers.consequences_1_choose;
  const secondary = answers.consequences_2_choose;
  const tertiary = answers.consequences_3_choose;

  let posterImage = answers.posterImage;
  if (posterImage === undefined) {
    Sentry.captureMessage("Expected posterImage to be defined but it wasn't");
    posterImage = getRandomPoster(category);
  }
  let theme = answers.theme;
  if (theme === undefined) {
    Sentry.captureMessage("Expected theme to be defined but it wasn't");
    theme = getRandomTheme();
  }

  const post = {
    // id is only used when fetching from aggregator to use as keys in map
    id: id,
    title,
    image: posterImage,
    theme,
    fragment: t(["categories", category, "fragments", fragment, "title"]),
    demographics: {
      group: t(["categories", category, "perspectives", perspective]),
      timeline: t(["categories", category, "ages", age]),
    },
    details: {
      who,
      what,
      where,
      why,
    },
    consequences: {
      direct,
      secondary,
      tertiary,
    },
  };

  return post;
}
